import React from 'react';
import { PixelStreamingCommunicator } from '../../sdk/PixelStreamingCommunicator';

interface NavigationModesProps {
  activeMode: 'building' | 'tour' | 'drone';
  onModeChange: (mode: 'building' | 'tour' | 'drone') => void;
  communicator: PixelStreamingCommunicator;
  disabled?: boolean;
}

export const NavigationModes: React.FC<NavigationModesProps> = ({
  activeMode,
  onModeChange,
  communicator,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleModeChange = (mode: 'building' | 'tour' | 'drone') => {
    onModeChange(mode);
    if (communicator) {
      communicator.setNavigationMode(mode);
    }
    setIsOpen(false);
  };

  const getModeLabel = (mode: 'building' | 'tour' | 'drone') => {
    switch (mode) {
      case 'building': return 'Gebäude Ansicht';
      case 'tour': return 'Besichtigung';
      case 'drone': return 'Drohnen Modus';
    }
  };

  const getModeIcon = (mode: 'building' | 'tour' | 'drone') => {
    switch (mode) {
      case 'building':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/>
            <path d="M9 22v-4h6v4"/>
            <path d="M8 6h.01"/>
            <path d="M16 6h.01"/>
            <path d="M12 6h.01"/>
            <path d="M12 10h.01"/>
            <path d="M12 14h.01"/>
            <path d="M16 10h.01"/>
            <path d="M16 14h.01"/>
            <path d="M8 10h.01"/>
            <path d="M8 14h.01"/>
          </svg>
        );
      case 'tour':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <polyline points="16 11 16 7 18 7"/>
            <line x1="16" y1="3" x2="16" y2="11"/>
          </svg>
        );
      case 'drone':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l3 7h7l-5 5 2 7-7-4-7 4 2-7-5-5h7z"/>
            <path d="M3 3l3 3"/>
            <path d="M18 3l3 3"/>
            <path d="M3 18l3 3"/>
            <path d="M18 18l3 3"/>
          </svg>
        );
    }
  };

  return (
    <div className="navigation-modes-dropdown">
      <button
        className="navigation-modes-dropdown__trigger"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
      >
        {getModeIcon(activeMode)}
        <span>{getModeLabel(activeMode)}</span>
        <svg
          className={`navigation-modes-dropdown__arrow ${isOpen ? 'open' : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {isOpen && (
        <div className="navigation-modes-dropdown__menu">
          <button
            className={`navigation-modes-dropdown__option ${activeMode === 'building' ? 'active' : ''}`}
            onClick={() => handleModeChange('building')}
          >
            {getModeIcon('building')}
            <span>Gebäude Ansicht</span>
          </button>
          <button
            className={`navigation-modes-dropdown__option ${activeMode === 'tour' ? 'active' : ''}`}
            onClick={() => handleModeChange('tour')}
          >
            {getModeIcon('tour')}
            <span>Besichtigung</span>
          </button>
          <button
            className={`navigation-modes-dropdown__option ${activeMode === 'drone' ? 'active' : ''}`}
            onClick={() => handleModeChange('drone')}
          >
            {getModeIcon('drone')}
            <span>Drohnen Modus</span>
          </button>
        </div>
      )}
    </div>
  );
};
